const ResumeApi = [
  {
    id: 1,
    category: "education",
    institute: "East West University",
    year: 2021,
    major: 'Computer Science And Engineering (CSE)',
    exam: "Bachelor Of Science (BSC)"
  },
  {
    id: 2,
    category: "education",
    institute: "Ideal College, Dhanmondi",
    year: 2016,
    major: 'Science',
    exam: "Higher Secondary Certificate (HSC)"
  },
  {
    id: 3,
    category: "education",
    institute: "Mirpur Bangla High School",
    year: 2014,
    major: 'Science',
    exam: "Secondary School Certificate (SSC)"
  }
]

export default ResumeApi
